import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fd5e173"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }),
    /*#__PURE__*/_createTextVNode("หนังสือคำสั่ง")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "จัดการข้อมูลหนังสือคำสั่งแต่งตั้งคณะ ร.นรม./รมต.นร.")
], -1))
const _hoisted_3 = { class: "card-body my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CabinetFormComponent = _resolveComponent("CabinetFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cabinetComponent), {
          "cabinet-id": _ctx.cabinetId,
          onToggle: _ctx.toggleCabinet,
          onShow: _ctx.show
        }, null, 40, ["cabinet-id", "onToggle", "onShow"]))
      ])
    ]),
    _createVNode(_component_CabinetFormComponent, {
      ref: "cabinetForm",
      "cabinet-id": _ctx.cabinetId
    }, null, 8, ["cabinet-id"])
  ], 64))
}